(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-topbar"]) return;
  try {
    

  jQuery( document ).ready(function() {
	jQuery('.choose-category').click(function(event) {
		jQuery('.category-filter-menu').toggle();
		event.preventDefault();
	});
  });


  } catch(e) { console.error(e); }
})();
})();
